module.exports = __webpack_public_path__ + "img/save-loading.54808660.svg";